import React from 'react';
import InterestTransactionsVM from './InterestTransactionsVM';
import { observer } from 'mobx-react';
import InterestTransactionsLookup from '../Models/Lookups/InterestTransactionsLookup';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { dateFormatYYYYMMDD } from '../../../Common/Components/Helpers/Formatting';

interface IInterestTransactionsProps {
    viewModel: InterestTransactionsVM;
}

@observer
export default class InterestTransactions extends React.Component<IInterestTransactionsProps> {

    constructor(props: IInterestTransactionsProps) {
        super(props);
    }

    public render() {
        const viewModel = this.props.viewModel;

        return (
          <>
          <Neo.Card>
          {viewModel.interestTransactionsPageManager.totalRecords > 0 && 
              <div className="inner-container">
                <Neo.Pager
                  pageManager={viewModel.interestTransactionsPageManager}
                  pageControlProps={{ pageSizeLabel: "Show" }}
                >
                  <div className="horizontalScroll inner-container">
                    <NeoGrid.Grid<InterestTransactionsLookup> className={"table-striped"}>
                      {(item, meta) => (
                        <NeoGrid.RowGroup>
                          <NeoGrid.Row>
                            <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                            <NeoGrid.Column display={meta.eventDetail} label={TextConstants.Labels.EventDetail} />
                            <NeoGrid.Column display={meta.eventID} label={TextConstants.Labels.EventID} />
                            <NeoGrid.Column label={TextConstants.Labels.EventDate}> {dateFormatYYYYMMDD(item.eventDate)} </NeoGrid.Column>
                            <NeoGrid.Column display={meta.amountNC} label={TextConstants.Labels.AmountNC}/>
                            <NeoGrid.Column display={meta.excluded} label={TextConstants.Labels.Excluded} />                             
                          </NeoGrid.Row>
                        </NeoGrid.RowGroup>
                      )}
                    </NeoGrid.Grid>
                  </div>
                </Neo.Pager>
              </div>
              }
              {viewModel.interestTransactionsPageManager.totalRecords <= 0 && (
                <div className="col-md-12 p-0 text-center">
                  {TextConstants.GeneralText.NoRecords}
                </div>
              )}
            </Neo.Card>
          
        </>
        );
    }
}